// extracted by mini-css-extract-plugin
module.exports =  {"gwMediaSidebarWrapper":"MediaSideBar_gwMediaSidebarWrapper__6S1qt","player":"MediaSideBar_player__fXdZf"};